import { SERVER_URI } from '../Constant/server'
import { apiGet, apiPost, apiPost1, apiPut, apiPut1 } from '../utils/axios'

const ADD_NEW_OCCASION = SERVER_URI + '/ocation/add-new-occasion';
const GET_OCCASION = SERVER_URI + '/ocation/get-occasion';
const UPDATE_OCCASION = SERVER_URI + '/ocation/update-ocation';
const UPDATE_STATUS = SERVER_URI + '/ocation/update-status/';

export default {
    addNewOccasion: async function (payload) {
        return apiPost(ADD_NEW_OCCASION, payload);
    },
    getOccasion: async function (payload) {
        return apiPost(GET_OCCASION, payload);
    },
    updateOccasion: async function (payload) {
        return apiPost(UPDATE_OCCASION, payload);
    },
    updateStatus: async function (id) {
        return apiGet(UPDATE_STATUS + id);
    }
}

